module.exports = __webpack_public_path__ + "media/images/5-70c6d7bb33a23d49617f06d468ef9c4a.jpg";